import { render, staticRenderFns } from "./input-address.vue?vue&type=template&id=0ad04dfd&"
import script from "./input-address.vue?vue&type=script&lang=js&"
export * from "./input-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports